import { AccredibleThemeableMultipleSearchInputComponentModule } from '@accredible-frontend-v2/forms/multiple-search-input';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { ProfileListSkillFilterComponent } from './profile-list-skill-filter.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AccredibleThemeableMultipleSearchInputComponentModule,
    TranslocoModule,
  ],
  exports: [ProfileListSkillFilterComponent],
  declarations: [ProfileListSkillFilterComponent],
})
export class ProfileListSkillFilterModule {}
